import { RefObject, useEffect } from 'react'

export const useClickOutside = (
  ref: RefObject<HTMLElement>,
  callback: () => void,
  additionalCondition: boolean = true,
  debounce: number = 0,
) => {
  useEffect(() => {
    let timer: NodeJS.Timeout | null = null

    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as HTMLDivElement) && additionalCondition) {
        timer = setTimeout(callback, debounce)
      }
    }

    if (additionalCondition) {
      document.addEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)

      if (timer) {
        clearTimeout(timer)
      }
    }
  }, [ref, callback, additionalCondition, debounce])
}
